// Телеметрия в шапке звонка (`GET /api/calls`): бэк материализует свёртку
// отчёта в колонки, чтобы список показывал качество звонка без разбора JSON.
// Поля читаются defensively: список может прийти от бэка без них — тогда
// карточка обходится фактами.
export interface CallCardTelemetry {
  turns: number
  perceivedP50Ms: number
  perceivedMaxMs: number
  faoP50Ms: number
  // null — бэк статуса не отдал; false — движок не записал телеметрию локально
  persistOk: boolean | null
  intentHint: string
  language: string
  llmTarget: string
  answeredAt: string
  promptTokens: number
  cachedTokens: number
  prematureEou: number
  llmLengthFinish: number
  pacerUnderruns: number
}

const num = (v: unknown): number => (typeof v === 'number' && Number.isFinite(v) ? v : 0)
const str = (v: unknown): string => (typeof v === 'string' ? v : '')

export function callCardTelemetry(call: unknown): CallCardTelemetry {
  const c = typeof call === 'object' && call !== null ? (call as Record<string, unknown>) : {}
  return {
    turns: num(c.turns),
    perceivedP50Ms: num(c.perceived_p50_ms),
    perceivedMaxMs: num(c.perceived_max_ms),
    faoP50Ms: num(c.fao_p50_ms),
    persistOk: typeof c.persist_ok === 'boolean' ? c.persist_ok : null,
    intentHint: str(c.intent_hint),
    language: str(c.language),
    llmTarget: str(c.llm_target),
    answeredAt: str(c.answered_at),
    promptTokens: num(c.prompt_tokens),
    cachedTokens: num(c.cached_tokens),
    prematureEou: num(c.premature_eou),
    llmLengthFinish: num(c.llm_length_finish),
    pacerUnderruns: num(c.pacer_underruns),
  }
}
